<template>
    <div class="main">
        <Overlay :show="loading">
            <div class="loading">
                <Loading/>
                加载中
            </div>
        </Overlay>
        <!--        <div class="title">-->
        <!--            <div>恭喜 “张三” 开出豪华大奖 玫瑰花*2</div>-->
        <!--        </div>-->
        <div class="award-list">
            <div v-for="(item,index) in prizes" class="award-list-item" :key="index">
                <img :src="'/api/resource/resource/resource/download/'+item.icon + '?imgStyleName=no_watermark_compress'" alt="" width="40px" height="40px"/>
                <div>x{{ item.rewardNumber }}</div>
            </div>
        </div>
        <div class="treasure-image">
            <img v-if="!lottery.preview" v-bind:class="{'shake':lottery.loading}" src="/assets/lottery-game/treatreasuresure/unopen.png" alt="" height="200px"/>
            <img v-if="lottery.preview" src="/assets/lottery-game/treatreasuresure/open.png" alt="" height="200px"/>
        </div>
        <div class="tips">您当前还剩余 {{ config.balance }} 次抽奖机会</div>
        <van-row class="button-group">
            <van-col span="8">
                <div class="button-group-item">
                    <div @click="()=>startCallback(1)" class="button-item">抽1次</div>
                    <div class="button-group-item-price">{{ getPrice(1) }}足币</div>
                </div>
            </van-col>
            <van-col span="8">
                <div class="button-group-item">
                    <div @click="()=>startCallback(10)" class="button-item">抽10次</div>
                    <div class="button-group-item-price">{{ getPrice(10) }}足币</div>
                    <div class="button-group-item-price">送1次</div>
                </div>
            </van-col>
            <van-col span="8">
                <div class="button-group-item">
                    <div @click="()=>startCallback(100)" class="button-item">抽100次</div>
                    <div class="button-group-item-price">{{ getPrice(100) }}足币</div>
                    <div class="button-group-item-price">送12次</div>
                </div>
            </van-col>
        </van-row>
        <div class="members" v-if="record.length >= 1">
            <marquee direction="up" scrollamount="2">
                <div class="members-item" v-for="(item, index) in record" :key="index">
                    <div style="flex:1">恭喜 {{item.nickname}} 抽中 {{item.name}}</div>
                    <div>x{{item.number}}</div>
                </div>
            </marquee>
        </div>
        <div class="note">
            <span class="note-title">活动规则</span>
            <span class="note-content" v-html="note()"></span>
        </div>
        <van-overlay :show="lottery.preview" :lock-scroll="false" @click="lottery.preview = false">
            <div class="award-result">
                <div class="award-result-body">
                    <div class="award-result-body-title">恭喜你，中奖啦</div>
                    <div class="award-result-body-body">
                        <div v-for="(item,index) of lottery.data.reward" :key="index" class="award-result-body-body-item">
                            <div style="width: 40px;line-height: 30px;color: #BBBBBB">{{ index + 1 }}.</div>
                            <div><img :src="'/api/resource/resource/resource/download/'+item.icon + '?imgStyleName=no_watermark_compress'" height="30px" alt=""/></div>
                            <div class="award-result-body-body-item-body"></div>
                            <div class="award-result-body-body-item-text">{{ item.name }} x{{ item.rewardNumber }}</div>
                        </div>
                    </div>
                    <div class="award-result-body-desc">
                        <div>共获得{{ lottery.data.reward.length }}个奖品</div>
                        <div>账户余额: {{ lottery.data.currencyBalance }} 足币</div>
                    </div>
                    <div>
                        <div class="award-result-button">
                            继续抽奖
                        </div>
                    </div>
                    <div style="font-size: 12px;color: #DDD;margin-top: 5px">奖励到账可能存在延迟，请注意查收</div>
                </div>
            </div>
        </van-overlay>
    </div>
</template>

<script>
import {Base64} from "js-base64";
import {Dialog, Overlay, Loading} from "vant";

export default {
    components: {Overlay, Loading},
    data() {
        return {
            // 是否加载中
            loading: true,
            // 中奖记录
            record:[],
            // 抽奖活动信息
            config: {
                // 活动规则
                note: "",
                // 余额
                balance: 0,
                // 价格
                price: 0,
            },
            // 奖励列表
            prizes: [],
            // 抽奖数据对象
            lottery: {
                // 是否抽奖中
                loading: false,
                // 奖励预览
                preview: false,
                // 抽奖结果数据对象
                data: {
                    // 抽奖余额
                    balance: 0,
                    // 足币余额
                    currencyBalance: 0,
                    // 奖励列表
                    reward: []
                }
            },
        }
    },
    mounted() {
        // 初始化大转盘大小
        this.size = document.documentElement.clientWidth - (20 * 2);

        // 加载活动信息
        this.loading = true;
        this.$axios.post('/api/user/lottery/lottery-activity-config/get-activity/bx', {}, {headers: {"token": this.getToken()}}).then((res) => {
            if (res.code !== 200) {
                Dialog.alert({message: res.msg ?? "请求异常，请重试", theme: 'round-button'});
                return;
            }

            if (res.data == null) {
                Dialog.alert({message: '活动未开始或已结束。', theme: 'round-button'});
                return;
            }
            this.config = res.data;

            // 设置奖励内容
            this.prizes = res.data.reward;

            // 查询中奖记录
            this.$axios.post(`/api/user/lottery/user-lottery-record/listByConfigId/${res.data.id}`, {}, {headers: {"token": this.getToken()}}).then((recordRes)=>{
                if(recordRes.code === 200) this.record = recordRes.data;
            });
        }).finally(() => {
            this.loading = false;
        });
    },
    methods: {
        /**
         * 获得描述文本信息
         * @returns {string | undefined} 活动规则信息
         */
        note() {
            return this.config?.note?.replace(/\n/g, '<br/>');
        },

        /**
         * 获得价格
         * @param number 次数
         */
        getPrice(number) {
            return this.config.price * number;
        },

        /**
         * 开始抽奖
         */
        startCallback(number) {
            if (this.lottery.loading) return;
            this.lottery.loading = true;
            this.$axios.post(`/api/user/lottery/lottery-activity-config/start/${this.config.id}?number=${number}`, {}, {headers: {"token": this.getToken()}}).then((res) => {
                if (res.code !== 200) {
                    Dialog.alert({message: res.msg ?? "请求异常，请重试", theme: 'round-button'});
                    return;
                }

                // 更新余额
                this.config.balance = res.data.balance;
                this.lottery.preview = true;
                this.lottery.data = res.data;
            }).finally(() => this.lottery.loading = false);
        },
        /**
         * 抽奖结束回调
         * @param prize 奖品
         */
        endCallback(prize) {
            if (!prize || !prize.name) return;
            if (prize.rewardNumber <= 0) {
                Dialog.alert({message: '很遗憾，您抽中了 ' + prize.name, theme: 'round-button'});
            } else {
                Dialog.alert({message: '恭喜您获得 ' + prize.name, theme: 'round-button'});
            }
        },
        /**
         * 获得浏览器传递的token
         * @returns {string | undefined} Token信息
         */
        getToken() {
            let token = this.$route.query?.token;
            if (token == null) {
                Dialog.alert({message: '活动加载失败', theme: 'round-button'});
                return;
            }
            return Base64.decode(token);
        },
    }
}
</script>

<style scoped>
.main {
    width: 100%;
    background: #2d2741;
    padding: 40px 0;
}

.loading {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: #FFFFFF;
}

.title {
    text-align: center;
    color: orange;
    font-weight: bold;
    padding: 10px;
    background: #6B1CC7;
}

.award-list {
    overflow-x: scroll;
    white-space: nowrap;
    padding: 0 20px;
}

.award-list::-webkit-scrollbar {
    display: none;
}

.award-list-item {
    padding: 10px;
    background: #6B1CC7;
    display: inline-block;
    margin-right: 10px;
    border-radius: 10px;
    text-align: center;
    color: #FFF;
    font-size: 12px;
}

.award-list-item:last-child {
    margin: 0;
}

.button-group {

}

.button-group-item {
    text-align: center;
    color: orange;
}

.button-group-item-price {
    margin: 5px;
    font-size: 12px;
}

.van-col, .treasure-image {
    display: flex;
    justify-content: center;
    align-items: center;
}

.treasure-image {
    margin-top: 20px;
}

.shake {
    position: relative;
    left: 0;
    animation: shake 0.5s ease-in-out 0s infinite alternate;
}

@keyframes shake {
    0% {
        transform: rotateZ(0deg);
    }
    25% {
        transform: rotateZ(15deg);
    }
    50% {
        transform: rotateZ(0deg);
    }
    75% {
        transform: rotateZ(-15deg);
    }
    100% {
        transform: rotateZ(0deg);
    }
}

.button-item {
    display: inline-block;
    color: #FFF;
    padding: 8px;
    border-radius: 50px;
    text-align: center;
    width: 80px;
    background: linear-gradient(60deg, #E72AFB 0%, #8500F9 100%);
}

.tips {
    color: #6B1CC7;
    text-align: center;
    background: #FFF;
    margin: 20px;
    padding: 10px;
    border-radius: 10px;
}

/*.game {*/
/*    padding: 20px;*/
/*}*/

.note {
    margin: 20px;
    padding: 15px;
    background: #FFFFFF;
    border-radius: 10px;
}

.note .note-title {
    display: block;
    font-size: 18px;
    font-weight: 500;
    color: #000000;
}

.note .note-content {
    display: block;
    color: #666666;
    margin-top: 10px;
    font-size: 14px;
    text-align: left;
}

.award-result {
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
}

.award-result-body {
    background: #FFF;
    width: 60%;
    height: 400px;
    border-radius: 10px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center
}

.award-result-body-title {
    text-align: center;
    font-weight: bold;
}

.award-result-body-body {
    flex: 1;
    overflow-y: scroll;
    border: 1px dashed #EEE;
    width: 100%;
    margin: 20px 0;
    border-radius: 20px;
    padding: 10px;
}

.award-result-body-body-item {
    padding: 10px;
    display: flex;
    border-bottom: 1px dashed #EEE;
}

.award-result-body-body-item-body {
    flex: 1;
}

.award-result-body-body-item-text {
    line-height: 30px;
}

.award-result-body-desc {
    text-align: center;
    font-size: 14px;
    color: #BBB;
}

.award-result-button {
    width: 100px;
    background: linear-gradient(90deg, orange 0%, #ffb713 100%);
    color: #FFF;
    padding: 10px 30px;
    text-align: center;
    border-radius: 30px;
    margin-top: 20px;
}

marquee {
    display: block;
    width: 100%;
    height: 30px;
    margin: 20px auto 0;
    padding: 15px;
    box-sizing: border-box;
}

marquee .members-item {
    padding: 5px 10px;
    background: rgba(0, 0, 0, 0.30);
    margin-bottom: 10px;
    border-radius: 5px;
    color: #FFF;
    display: flex;
    font-size: 14px;
}
</style>
